"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7636,7862],{

/***/ 37710:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(97582);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(46523);
/* harmony import */ var _opendoor_cinderblocks_platform_auth_AccountForm__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21335);
/* harmony import */ var _opendoor_observability_slim__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74593);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36808);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(js_cookie__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67945);
/* harmony import */ var _globals__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35480);
/* harmony import */ var _shared_AccountConnector__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45949);












var Sentry = _opendoor_observability_slim__WEBPACK_IMPORTED_MODULE_2__/* .globalObservability.getSentryClient */ .w.getSentryClient();
var UNAUTHORIZED_STATUS_CODE = 401;
var AccountFormPage = function(param) {
    var logIn = param.logIn, register = param.register, requestHumanStatus = param.requestHumanStatus, hasGeneratedPassword = param.hasGeneratedPassword, _isNewHuman = param.isNewHuman, isNewHuman = _isNewHuman === void 0 ? false : _isNewHuman, loginRequestStatus = param.loginRequestStatus, humanStatusRequestStatus = param.humanStatusRequestStatus, registrationRequestStatus = param.registrationRequestStatus, config = param.config, email = param.email, emailPrefill = param.emailPrefill, requestResetPassword = param.requestResetPassword, redirectTo = param.redirectTo, maybeFetchSessionInfo = param.maybeFetchSessionInfo, loggedIn = param.loggedIn, serverLoginRedirect = param.serverLoginRedirect, updatedPassword = param.updatedPassword;
    var getSignInText = function(config) {
        var loginHeaderText;
        var registrationHeaderText;
        switch(config){
            case "resaleClosingDashboard":
                loginHeaderText = "Sign in to get back to your dashboard";
                registrationHeaderText = "Sign up to get access to your dashboard";
                break;
            default:
                break;
        }
        return {
            loginHeaderText: loginHeaderText,
            registrationHeaderText: registrationHeaderText
        };
    };
    var ref = getSignInText(config), loginHeaderText = ref.loginHeaderText, registrationHeaderText = ref.registrationHeaderText;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        _opendoor_observability_slim__WEBPACK_IMPORTED_MODULE_2__/* .analytics.register */ .co.register({
            login: js_cookie__WEBPACK_IMPORTED_MODULE_3___default().get("login-test") || "no-cookie"
        });
        _opendoor_observability_slim__WEBPACK_IMPORTED_MODULE_2__/* .analytics.trackEvent */ .co.trackEvent("login", "load", undefined, {
            email: email,
            config: config,
            redirectTo: redirectTo,
            emailPrefill: emailPrefill
        });
        maybeFetchSessionInfo();
        redirectIfLoggedIn();
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        redirectIfLoggedIn();
        if (loginRequestStatus && loginRequestStatus.error && loginRequestStatus.statusCode !== UNAUTHORIZED_STATUS_CODE) {
            var ref;
            (ref = Sentry.captureException) === null || ref === void 0 ? void 0 : ref.call(Sentry, loginRequestStatus.error);
        }
    }, [
        loggedIn,
        loginRequestStatus
    ]);
    var trackLoginEvent = function(topic, label, extra) {
        _opendoor_observability_slim__WEBPACK_IMPORTED_MODULE_2__/* .analytics.trackEvent */ .co.trackEvent("login", topic, label, extra);
    };
    var redirectIfLoggedIn = function() {
        if (loggedIn) {
            _opendoor_observability_slim__WEBPACK_IMPORTED_MODULE_2__/* .analytics.trackEvent */ .co.trackEvent("login", "redirect", undefined, {
                email: email,
                config: config,
                redirectTo: redirectTo,
                serverLoginRedirect: serverLoginRedirect
            });
            var redirectUrl;
            // redirectTo="/" means "came from homepage" - not a real destination preference
            var hasClientRedirect = redirectTo && redirectTo !== "/";
            var hasServerRedirect = serverLoginRedirect && serverLoginRedirect !== "/";
            if (!hasClientRedirect && hasServerRedirect) {
                redirectUrl = serverLoginRedirect;
            } else if (hasClientRedirect) {
                // allow redirection to relative urls & opendoor.com absolute urls
                if (_globals__WEBPACK_IMPORTED_MODULE_5__/* .REDIRECT_URLS_REGEX.test */ .Ut.test(redirectTo)) {
                    // absolute path
                    redirectUrl = redirectTo;
                } else {
                    // if redirectTo does not match regex it is a relative path
                    // add `/` to enforce relative only if it does not already have one
                    redirectUrl = "".concat(redirectTo[0] === "/" ? "" : "/").concat(redirectTo);
                }
            }
            window.location.assign(redirectUrl || "/");
        }
    };
    var handlePasswordlessLoginRequest = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function(email) {
            var response, errors;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        trackLoginEvent("one-time-password", "request", {
                            email: email,
                            redirectTo: redirectTo
                        });
                        return [
                            4,
                            _api__WEBPACK_IMPORTED_MODULE_4__/* .requestNewTokenByEmail */ .fs(email, redirectTo)
                        ];
                    case 1:
                        response = _state.sent();
                        if (!response || !response.data || response.errors) {
                            errors = response && response.errors;
                            trackLoginEvent("one-time-password", "error", {
                                email: email,
                                errors: errors
                            });
                            return [
                                2,
                                {
                                    success: false,
                                    errors: errors
                                }
                            ];
                        }
                        trackLoginEvent("one-time-password", "success", {
                            email: email
                        });
                        return [
                            2,
                            {
                                success: true
                            }
                        ];
                }
            });
        });
        return function handlePasswordlessLoginRequest(email) {
            return _ref.apply(this, arguments);
        };
    }();
    var headerText = loginHeaderText;
    if (updatedPassword) {
        headerText = "Your password was successfully changed. Please sign in.";
    }
    var onRegister = function(email, name, password, phone, googleIDToken) {
        register(email, name, password, phone, googleIDToken);
        //   Do not remove - GTM event for account creation
        _opendoor_observability_slim__WEBPACK_IMPORTED_MODULE_2__/* .analytics.trackEvent */ .co.trackEvent("session", "register", "account-creation", {
            email: email
        });
    };
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_10__/* .Box */ .x, {
        py: "$24x",
        px: "$12x",
        mx: "auto",
        justifyContent: "center",
        alignItems: "center",
        $largerThanMD: {
            py: "$36x",
            px: 0
        },
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_opendoor_cinderblocks_platform_auth_AccountForm__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            analyticsName: "cosmos-account-form",
            loginHeaderText: headerText,
            registrationHeaderText: registrationHeaderText,
            email: email || emailPrefill,
            hasGeneratedPassword: hasGeneratedPassword,
            error: loginRequestStatus.error || humanStatusRequestStatus.error || registrationRequestStatus.error,
            passwordLoading: !!serverLoginRedirect || loginRequestStatus.isLoading || registrationRequestStatus.isLoading,
            emailLoading: humanStatusRequestStatus.isLoading,
            isNewHuman: isNewHuman,
            onLogin: logIn,
            overrideHasSubmittedEmailCheckForLogin: !!emailPrefill,
            onRegister: onRegister,
            onHumanStatusRequest: requestHumanStatus,
            showGoogleAuth: true,
            requestResetPassword: requestResetPassword,
            onPasswordlessLoginRequest: function(email) {
                return handlePasswordlessLoginRequest(email);
            }
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = ((0,_shared_AccountConnector__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(AccountFormPage));


/***/ }),

/***/ 45949:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(15467);
/* harmony import */ var _opendoor_shared_fe_build_store_session_actions__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5515);
/* harmony import */ var _opendoor_shared_fe_build_store_session_actions__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_opendoor_shared_fe_build_store_session_actions__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _opendoor_shared_fe_build_store_session_selectors__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29884);
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42279);




var mapStateToProps = (0,reselect__WEBPACK_IMPORTED_MODULE_3__/* .createSelector */ .P1)([
    _opendoor_shared_fe_build_store_session_selectors__WEBPACK_IMPORTED_MODULE_2__.human,
    _opendoor_shared_fe_build_store_session_selectors__WEBPACK_IMPORTED_MODULE_2__.infoIsLoaded,
    _opendoor_shared_fe_build_store_session_selectors__WEBPACK_IMPORTED_MODULE_2__.infoIsLoading,
    _opendoor_shared_fe_build_store_session_selectors__WEBPACK_IMPORTED_MODULE_2__.loggedIn,
    _opendoor_shared_fe_build_store_session_selectors__WEBPACK_IMPORTED_MODULE_2__.loginRequestStatus,
    _opendoor_shared_fe_build_store_session_selectors__WEBPACK_IMPORTED_MODULE_2__.humanStatusRequestStatus,
    _opendoor_shared_fe_build_store_session_selectors__WEBPACK_IMPORTED_MODULE_2__.registrationRequestStatus,
    _opendoor_shared_fe_build_store_session_selectors__WEBPACK_IMPORTED_MODULE_2__.serverLoginRedirect,
    _opendoor_shared_fe_build_store_session_selectors__WEBPACK_IMPORTED_MODULE_2__.email,
    _opendoor_shared_fe_build_store_session_selectors__WEBPACK_IMPORTED_MODULE_2__.hasGeneratedPassword,
    _opendoor_shared_fe_build_store_session_selectors__WEBPACK_IMPORTED_MODULE_2__.isNewHuman, 
], function(human, infoIsLoaded, infoIsLoading, loggedIn, loginRequestStatus, humanStatusRequestStatus, registrationRequestStatus, serverLoginRedirect, email, hasGeneratedPassword, isNewHuman) {
    return {
        human: human,
        infoIsLoaded: infoIsLoaded,
        infoIsLoading: infoIsLoading,
        loggedIn: loggedIn,
        loginRequestStatus: loginRequestStatus,
        humanStatusRequestStatus: humanStatusRequestStatus,
        registrationRequestStatus: registrationRequestStatus,
        serverLoginRedirect: serverLoginRedirect,
        email: email,
        hasGeneratedPassword: hasGeneratedPassword,
        isNewHuman: isNewHuman
    };
});
var mapDispatchToProps = function(dispatch) {
    return {
        maybeFetchSessionInfo: function() {
            dispatch(_opendoor_shared_fe_build_store_session_actions__WEBPACK_IMPORTED_MODULE_1__.maybeFetchSessionInfo());
        },
        maybeLogOut: function() {
            dispatch(_opendoor_shared_fe_build_store_session_actions__WEBPACK_IMPORTED_MODULE_1__.maybeLogOut());
        },
        logIn: function(email, password, googleIDToken, facebookIDToken) {
            dispatch(_opendoor_shared_fe_build_store_session_actions__WEBPACK_IMPORTED_MODULE_1__.logIn(email, password, googleIDToken, facebookIDToken));
        },
        requestHumanStatus: function(email) {
            dispatch(_opendoor_shared_fe_build_store_session_actions__WEBPACK_IMPORTED_MODULE_1__.requestHumanStatus(email));
        },
        requestResetPassword: function(email) {
            dispatch(_opendoor_shared_fe_build_store_session_actions__WEBPACK_IMPORTED_MODULE_1__.requestPasswordReset(email));
        },
        register: function(email, name, password, phone, googleIDToken, facebookIDToken, passwordlessToken, hasGeneratedPassword, redirectUrl) {
            dispatch(_opendoor_shared_fe_build_store_session_actions__WEBPACK_IMPORTED_MODULE_1__.register(email, name, password, phone, googleIDToken, facebookIDToken, passwordlessToken, hasGeneratedPassword, redirectUrl));
        }
    };
};
/**
 * This is an HOC that provides access to the session state via props
 *
 * @deprecated Use @opendoor/auth-fe::useAuth instead
 */ var AccountConnector = (0,react_redux__WEBPACK_IMPORTED_MODULE_0__/* .connect */ .$j)(mapStateToProps, mapDispatchToProps);
/* harmony default export */ __webpack_exports__["Z"] = (AccountConnector);


/***/ }),

/***/ 3542:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(97582);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(35944);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(15467);
/* harmony import */ var _opendoor_shared_fe_build_api_session__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26198);
/* harmony import */ var _opendoor_shared_fe_build_api_session__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_opendoor_shared_fe_build_api_session__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _opendoor_shared_fe_build_sagas__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2775);
/* harmony import */ var _opendoor_shared_fe_build_store_session__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95718);
/* harmony import */ var _opendoor_shared_fe_build_store_session__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_opendoor_shared_fe_build_store_session__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _opendoor_shared_fe_build_store_session_saga__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4544);
/* harmony import */ var _opendoor_shared_fe_build_store_session_saga__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_opendoor_shared_fe_build_store_session_saga__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var redux__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21597);
/* harmony import */ var redux_immutable__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(72739);
/* harmony import */ var redux_saga__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(87200);
/* harmony import */ var redux_saga_effects__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(92242);
/* harmony import */ var _globals__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(35480);













var sagas = function sagas() {
    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    (0,redux_saga_effects__WEBPACK_IMPORTED_MODULE_8__.all)([
                        (0,redux_saga_effects__WEBPACK_IMPORTED_MODULE_8__.fork)(new (_opendoor_shared_fe_build_store_session_saga__WEBPACK_IMPORTED_MODULE_4___default())(new (_opendoor_shared_fe_build_api_session__WEBPACK_IMPORTED_MODULE_1___default())(_globals__WEBPACK_IMPORTED_MODULE_9__/* .XSRF_COOKIE_KEY */ .x0, _globals__WEBPACK_IMPORTED_MODULE_9__/* .RAILS_URL */ .oF)).saga)
                    ])
                ];
            case 1:
                _state.sent();
                return [
                    2
                ];
        }
    });
};
var sagaMiddleware = (0,redux_saga__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)({
    onError: _opendoor_shared_fe_build_sagas__WEBPACK_IMPORTED_MODULE_2__/* .sagaMiddlewareErrorHandler */ .e
});
var composeEnhancers = ( true && window).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || redux__WEBPACK_IMPORTED_MODULE_5__/* .compose */ .qC;
var reducers = {
    session: (_opendoor_shared_fe_build_store_session__WEBPACK_IMPORTED_MODULE_3___default().reducer)
};
var store = (0,redux__WEBPACK_IMPORTED_MODULE_5__/* .createStore */ .MT)((0,redux_immutable__WEBPACK_IMPORTED_MODULE_6__/* .combineReducers */ .U)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, reducers)), undefined, composeEnhancers((0,redux__WEBPACK_IMPORTED_MODULE_5__/* .applyMiddleware */ .md)(sagaMiddleware)));
sagaMiddleware.run(sagas);
var ReduxWrapper = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)(react_redux__WEBPACK_IMPORTED_MODULE_0__/* .Provider */ .zt, {
        store: store,
        children: props.children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ReduxWrapper);


/***/ }),

/***/ 17919:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ useOnLoad; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

// Periodically we want to load something after the window has loaded. This will
// do that, it also adds a buffer so it's definitely "afterLoad", these are for
// low-priority things.
var useOnLoad = function() {
    var onLoadStateChange = function onLoadStateChange() {
        setTimeout(function() {
            return setIsAfterLoad(true);
        }, 1000);
    };
    var handleLoadStateCleanup = function handleLoadStateCleanup() {
        window.removeEventListener("load", onLoadStateChange);
    };
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(// handle ssr
    typeof document === "undefined" ? false : document.readyState === "complete"), isAfterLoad = ref[0], setIsAfterLoad = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (isAfterLoad) {
            handleLoadStateCleanup();
            return;
        }
        window.addEventListener("load", onLoadStateChange);
        return handleLoadStateCleanup;
    }, [
        isAfterLoad
    ]);
    return isAfterLoad;
};


/***/ }),

/***/ 47862:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ shared_LandingPageV2Layout; },
  "getJobPostingSchemaFromLoaderData": function() { return /* binding */ getJobPostingSchemaFromLoaderData; },
  "getLandingpageV2ServerSideProps": function() { return /* binding */ getLandingpageV2ServerSideProps; },
  "getPreloadsFromLoaderData": function() { return /* binding */ getPreloadsFromLoaderData; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/@opendoor/observability/dist/observability-slim.mjs
var observability_slim = __webpack_require__(74593);
// EXTERNAL MODULE: ./node_modules/@opendoor/shared-fe/build/faviconPath.js
var faviconPath = __webpack_require__(71390);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/cms/index.ts + 1 modules
var cms = __webpack_require__(96887);
// EXTERNAL MODULE: ./src/components/globals.ts
var globals = __webpack_require__(35480);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Box/Box.js
var Box = __webpack_require__(46523);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/theme/novo/components/text.mjs
var components_text = __webpack_require__(9225);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/theme/ODThemeLite.mjs
var ODThemeLite = __webpack_require__(69666);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/cms/utils.ts
var utils = __webpack_require__(46000);
;// CONCATENATED MODULE: ./src/cms/navHeaderUtils.ts


function extractNavData(header) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    var mainNavLinks = [];
    header === null || header === void 0 ? void 0 : (ref = header.fields) === null || ref === void 0 ? void 0 : (ref1 = ref.mainNav) === null || ref1 === void 0 ? void 0 : ref1.forEach(function(link) {
        // mainNav can now be ILpElementLink (simple) or ILpElementSimpleList (with sections)
        // Only extract simple links for mainNavLinks
        if (!(0,utils/* isSimpleLink */.$)(link)) return;
        if (!link.fields.text || !link.fields.url) return;
        mainNavLinks.push({
            name: link.fields.text,
            href: link.fields.url
        });
    });
    var menuPanelNavLinks = [];
    header === null || header === void 0 ? void 0 : (ref2 = header.fields) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.menuPanelNav) === null || ref3 === void 0 ? void 0 : ref3.forEach(function(link) {
        if (link.fields.text && link.fields.url) {
            menuPanelNavLinks.push({
                name: link.fields.text,
                href: link.fields.url
            });
        }
    });
    var ctaTitle = header === null || header === void 0 ? void 0 : header.fields.menuPanelCtaTitle;
    var ctaLink;
    if ((header === null || header === void 0 ? void 0 : (ref4 = header.fields) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.menuPanelCta) === null || ref5 === void 0 ? void 0 : ref5.fields.text) && (header === null || header === void 0 ? void 0 : (ref6 = header.fields) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.menuPanelCta) === null || ref7 === void 0 ? void 0 : ref7.fields.url)) {
        ctaLink = {
            name: header.fields.menuPanelCta.fields.text,
            href: header.fields.menuPanelCta.fields.url
        };
    }
    // Transform header.mainNav (union type) into MegaNavItem[] format
    var megaNavData = (0,cms/* transformHeaderNavToMegaNav */.$C)(header === null || header === void 0 ? void 0 : (ref8 = header.fields) === null || ref8 === void 0 ? void 0 : ref8.mainNav);
    return {
        mainNavLinks: mainNavLinks,
        menuPanelNavLinks: menuPanelNavLinks,
        megaNavData: megaNavData,
        ctaTitle: ctaTitle,
        ctaLink: ctaLink
    };
}

// EXTERNAL MODULE: ./src/components/shared/GlobalStyles.tsx
var GlobalStyles = __webpack_require__(54991);
// EXTERNAL MODULE: ./src/helpers/queryParams.ts
var queryParams = __webpack_require__(43552);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Text/index.js
var Text = __webpack_require__(76614);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Button/IconButton.js + 3 modules
var IconButton = __webpack_require__(61532);
;// CONCATENATED MODULE: ./src/components/landing-pages-v2/InspectionBanner.tsx
"use client";



var GiftIcon = function() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M18.5 21H5.5V12H3.5V8H20.5V12H18.5V21Z",
                fill: "url(#paint0_linear_4031_637)"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M12 8V21M12 8C11.6383 6.5094 11.0154 5.23501 10.2127 4.34311C9.41003 3.45121 8.46469 2.98314 7.5 2.99995C6.83696 2.99995 6.20107 3.26334 5.73223 3.73218C5.26339 4.20102 5 4.83691 5 5.49995C5 6.16299 5.26339 6.79887 5.73223 7.26772C6.20107 7.73656 6.83696 7.99995 7.5 7.99995M12 8C12.3617 6.5094 12.9846 5.23501 13.7873 4.34311C14.59 3.45121 15.5353 2.98314 16.5 2.99995C17.163 2.99995 17.7989 3.26334 18.2678 3.73218C18.7366 4.20102 19 4.83691 19 5.49995C19 6.16299 18.7366 6.79887 18.2678 7.26772C17.7989 7.73656 17.163 7.99995 16.5 7.99995M19 12V19C19 19.5304 18.7893 20.0391 18.4142 20.4142C18.0391 20.7893 17.5304 21 17 21H7C6.46957 21 5.96086 20.7893 5.58579 20.4142C5.21071 20.0391 5 19.5304 5 19V12M3 9C3 8.73478 3.10536 8.48043 3.29289 8.29289C3.48043 8.10536 3.73478 8 4 8H20C20.2652 8 20.5196 8.10536 20.7071 8.29289C20.8946 8.48043 21 8.73478 21 9V11C21 11.2652 20.8946 11.5196 20.7071 11.7071C20.5196 11.8946 20.2652 12 20 12H4C3.73478 12 3.48043 11.8946 3.29289 11.7071C3.10536 11.5196 3 11.2652 3 11V9Z",
                stroke: "#F9C940",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("defs", {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                    id: "paint0_linear_4031_637",
                    x1: "16",
                    y1: "9",
                    x2: "12",
                    y2: "21",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                            stopColor: "#A51C1C"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                            offset: "1",
                            stopColor: "#E12020"
                        })
                    ]
                })
            })
        ]
    });
};
var BANNER_DISMISSED_KEY = "inspection-banner-dismissed";
/**
 * Promotional banner for free home inspection report offer.
 * Part of experiment: growth-25-12-inspection-banner
 *
 * Impression tracking is handled at the Cloudflare Worker level.
 *
 * Figma: https://www.figma.com/design/PRkjHWTpRlrz6YFlekrChg/?node-id=4002-2104
 */ var InspectionBanner = function() {
    var ref = (0,react.useState)(true), isDismissed = ref[0], setIsDismissed = ref[1]; // Start hidden to prevent flash
    (0,react.useEffect)(function() {
        // Check localStorage on mount
        var dismissed = localStorage.getItem(BANNER_DISMISSED_KEY) === "true";
        setIsDismissed(dismissed);
    }, []);
    var handleDismiss = function() {
        setIsDismissed(true);
        localStorage.setItem(BANNER_DISMISSED_KEY, "true");
    };
    if (isDismissed) {
        return null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
        id: "inspection-banner",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        paddingVertical: "$3x",
        paddingHorizontal: "$4x",
        gap: "$3x",
        // Figma: #00278b (sem/color/background/state/hover/accent-brand)
        style: {
            backgroundColor: "#00278b"
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "flex-start",
                $largerThanSM: {
                    justifyContent: "center"
                },
                gap: "$2x",
                flex: 1,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                        flexShrink: 0,
                        display: "flex",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GiftIcon, {})
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* Text */.x, {
                        tag: "p",
                        typography: "$bodyMedium",
                        color: "white",
                        textAlign: "left",
                        $largerThanSM: {
                            textAlign: "center"
                        },
                        children: [
                            "Get a",
                            " ",
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                tag: "span",
                                typography: "$bodyMedium",
                                fontWeight: "$medium",
                                color: "white",
                                children: "FREE home inspection report"
                            }),
                            " ",
                            "($450 value) with your Opendoor offer"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                flexShrink: 0,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconButton/* CloseButton */.PZ, {
                    analyticsName: "cosmos-inspection-banner-close",
                    onPress: handleDismiss,
                    size: "small",
                    variant: "inverse"
                })
            })
        ]
    });
};
/* harmony default export */ var landing_pages_v2_InspectionBanner = (InspectionBanner);

// EXTERNAL MODULE: ./src/components/landing-pages-v2/shared/header/Header.tsx + 21 modules
var Header = __webpack_require__(76639);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/components/landing-pages-v2/useInspectionBannerExperiment.ts


var INSPECTION_BANNER_EXPERIMENT_KEY = "growth-25-12-inspection-banner";
/**
 * LocalStorage key for storing the experiment variant.
 * This allows us to pass the variant to the backend when creating a seller input
 * so it can be stored on the lead for Iterable attribution.
 */ var INSPECTION_BANNER_VARIANT_STORAGE_KEY = "inspection-banner-experiment-variant";
/**
 * Get the stored inspection banner experiment variant from localStorage.
 * This can be used when creating a seller input to pass the variant to the backend
 * for Iterable attribution tracking.
 */ function getStoredInspectionBannerVariant() {
    if (false) {}
    var stored = localStorage.getItem(INSPECTION_BANNER_VARIANT_STORAGE_KEY);
    if (stored === "treatment" || stored === "control") {
        return stored;
    }
    return null;
}
/**
 * Hook to get the inspection banner experiment variant from query params.
 * Returns 'treatment' to show the banner, 'control' for no banner,
 * or null while loading.
 *
 * The variant is bucketed at the Cloudflare Worker level using Amplitude local evaluation
 * and passed to Cosmos via the `inspection_banner_variant` query param.
 * Impression tracking is handled automatically by the CF Worker.
 *
 * The variant is also stored in localStorage so it can be passed to the backend
 * when creating a seller input for Iterable attribution tracking.
 */ function useInspectionBannerExperiment() {
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(null), variant = ref[0], setVariant = ref[1];
    var ref1 = (0,react.useState)(true), isLoading = ref1[0], setIsLoading = ref1[1];
    (0,react.useEffect)(function() {
        // Wait for router to be ready (query params populated)
        if (!router.isReady) {
            return;
        }
        // Read variant from query param (set by Cloudflare Worker)
        var queryVariant = router.query.inspection_banner_variant;
        var resolvedVariant = queryVariant === "treatment" ? "treatment" : "control";
        setVariant(resolvedVariant);
        setIsLoading(false);
        // Store variant in localStorage for backend attribution
        localStorage.setItem(INSPECTION_BANNER_VARIANT_STORAGE_KEY, resolvedVariant);
    }, [
        router.isReady,
        router.query.inspection_banner_variant
    ]);
    return {
        variant: variant,
        isLoading: isLoading
    };
}

// EXTERNAL MODULE: ./node_modules/@opendoor/auth-fe/dist/auth-fe.esm.js
var auth_fe_esm = __webpack_require__(95674);
// EXTERNAL MODULE: ./node_modules/@tamagui/core/dist/cjs/index.js
var cjs = __webpack_require__(86872);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Dialog/index.js + 7 modules
var Dialog = __webpack_require__(60179);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Button/Button.js
var Button = __webpack_require__(25923);
;// CONCATENATED MODULE: ./src/components/landing-pages-v2/VisitorModal.tsx




var GetCashOfferModal = function(entry) {
    var authentication = (0,auth_fe_esm/* useAuth */.aC)().authentication;
    var ref = (0,react.useState)(false), isOpen = ref[0], setIsOpen = ref[1];
    (0,react.useEffect)(function() {
        var timer;
        if (authentication.state === "not_authenticated") {
            var hasShownDialog = localStorage.getItem("getCashOfferModalShown");
            if (!hasShownDialog) {
                timer = setTimeout(function() {
                    setIsOpen(true);
                    localStorage.setItem("getCashOfferModalShown", "true");
                }, 400);
            }
        }
        return function() {
            return clearTimeout(timer);
        };
    }, [
        authentication.state
    ]);
    var handleClose = function() {
        setIsOpen(!isOpen);
    };
    var analyticsName = "cosmos-landing-page-visitor-modal-".concat(entry === null || entry === void 0 ? void 0 : entry.analyticsId);
    var largerThanSM = (0,cjs.useMedia)().largerThanSM;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dialog/* Dialog */.V, {
        isOpen: isOpen,
        dismissable: largerThanSM ? true : false,
        animation: "accelerateDecelerateFast",
        setIsOpen: handleClose,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
            maxWidth: 504,
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dialog/* Dialog.Content */.V.Content, {
                title: entry.title,
                titleProps: {
                    typography: "$subheaderLarge",
                    $largerThanSM: {
                        typography: "$headerLarge"
                    }
                },
                description: entry.description,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                    $largerThanSM: {
                        pt: "$24x"
                    },
                    pt: "$16x",
                    children: [
                        !largerThanSM && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* Button */.z, {
                            variant: "secondary",
                            size: "small",
                            analyticsName: analyticsName,
                            label: "Close",
                            onPress: handleClose
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* Button */.z, {
                            marginTop: "$4x",
                            variant: "primary",
                            size: "small",
                            $largerThanSM: {
                                size: "medium"
                            },
                            onPress: function() {
                                document.location.href = "https://www.opendoor.com/address-entry";
                            },
                            analyticsName: "".concat(analyticsName, "-cash-offer-cta"),
                            label: "Get a cash offer"
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var VisitorModal = (GetCashOfferModal);

;// CONCATENATED MODULE: ./src/components/landing-pages-v2/Layout.tsx















var MaintenanceBanner = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 716).then(__webpack_require__.bind(__webpack_require__, 40716));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(40716)
            ];
        }
    }
});
var Footer = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1243).then(__webpack_require__.bind(__webpack_require__, 71243));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(71243)
            ];
        }
    }
});
var Layout = function(param) {
    var header = param.header, slug = param.slug, footer = param.footer, extraLegalText = param.extraLegalText, showEligibilityLegal = param.showEligibilityLegal, showCustomerTestimonialLegal = param.showCustomerTestimonialLegal, showThePdpCopyrightLegal = param.showThePdpCopyrightLegal, showPromotionLegal = param.showPromotionLegal, children = param.children, showModal = param.showModal, modalTitle = param.modalTitle, modalDescription = param.modalDescription, modalAnalyticsId = param.modalAnalyticsId;
    var ref = useInspectionBannerExperiment(), inspectionBannerVariant = ref.variant;
    // Only show inspection banner on homepage variants for treatment group
    // Matches: '/', '/homepage-kt', '/homepage-v2', '/landing-pages-v2/homepage-kt', etc.
    var isHomepage = slug === "/" || slug.toLowerCase().includes("homepage");
    var showInspectionBanner = isHomepage && inspectionBannerVariant === "treatment";
    var navData = extractNavData(header);
    var mainNavLinks = navData.mainNavLinks, menuPanelNavLinks = navData.menuPanelNavLinks, megaNavData = navData.megaNavData, ctaTitle = navData.ctaTitle, ctaLink = navData.ctaLink;
    var getOfferExperiment = (0,queryParams/* default */.Z)().getOfferExperiment;
    var showGetCashOfferModal = showModal && getOfferExperiment === "treatment";
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ODThemeLite/* ThemedLite */.h, {
        baseTheme: "novo",
        team: "growth",
        launchDateString: new Date().toISOString(),
        // NOTE: This is a hack to fix responsive sizing due to issues in the feature's figma designs
        // TODO(@product-growth): Remove this when the design system is updated
        overrides: {
            components: {
                Text: {
                    sizes: UpdatedTextSizing
                },
                Heading: {
                    sizes: UpdatedTextSizing
                }
            }
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                        rel: "preconnect",
                        href: "https://images.opendoor.com"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                        rel: "dns-prefetch",
                        href: "https://images.opendoor.com"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                        rel: "preload",
                        crossOrigin: "anonymous",
                        href: "/fonts/graphik-regular/Graphik-Regular.woff2",
                        as: "font"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                        rel: "preload",
                        crossOrigin: "anonymous",
                        href: "/fonts/graphik-medium/Graphik-Medium.woff2",
                        as: "font"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                        rel: "preload",
                        crossOrigin: "anonymous",
                        href: "/fonts/graphik-semibold/Graphik-Semibold.woff2",
                        as: "font"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                        rel: "preload",
                        crossOrigin: "anonymous",
                        href: "/fonts/graphik-bold/Graphik-Bold.woff2",
                        as: "font"
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GlobalStyles/* default */.Z, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MaintenanceBanner, {}),
            showInspectionBanner && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(landing_pages_v2_InspectionBanner, {}),
            showGetCashOfferModal && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VisitorModal, {
                title: modalTitle,
                description: modalDescription,
                analyticsId: modalAnalyticsId
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                position: "relative",
                display: "block",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Header/* default */.Z, {
                        menuPanelNavLinks: menuPanelNavLinks,
                        mainNavLinks: mainNavLinks,
                        ctaTitle: ctaTitle,
                        ctaLink: ctaLink,
                        slug: slug,
                        megaNavData: megaNavData
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("main", {
                        tabIndex: -1,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                            width: "100%",
                            margin: 0,
                            display: "block",
                            children: [
                                children,
                                footer && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Footer, {
                                    footerTitle: footer.fields.footerTitle,
                                    footerNav: footer.fields.footerNav,
                                    sellInYourMarket: footer.fields.sellInYourMarket,
                                    googlePlaystoreLink: footer.fields.googlePlaystoreLink,
                                    appleStoreLink: footer.fields.appleStoreLink,
                                    helpCenterLink: footer.fields.helpCenterLink,
                                    backgroundColor: footer.fields.backgroundColor,
                                    extraLegalText: extraLegalText,
                                    showCustomerTestimonialLegal: showCustomerTestimonialLegal,
                                    showEligibilityLegal: showEligibilityLegal,
                                    showPromotionLegal: showPromotionLegal,
                                    showThePdpCopyrightLegal: showThePdpCopyrightLegal,
                                    locale: footer.sys.locale,
                                    aiPrompt: footer.fields.aiPrompt
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
/**
 * All the following typography overrides are for the 2023 Homepage Reskin project
 * https://www.figma.com/file/g2qLawddmhROv347l6EF7m/HP-Reskin?type=design&node-id=325-28241&mode=design&t=5CA6uSlmM7nuVuIC-0
 * TODO: re-assess overrides after experiment is over
 *
 * NOTE: This object gets deep merged w/ the novo theme so we only need to define the differences
 */ var UpdatedTextSizing = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, components_text/* sizes */.J), {
    100: {
        fontSize: [
            "14px",
            null,
            null,
            "18px"
        ],
        lineHeight: "140",
        letterSpacing: "-1.4"
    },
    // Used in FAQsDisplay, VideoHero, ReviewCard, MenuPanel
    110: {
        fontSize: [
            "16px",
            null,
            "14px",
            "16px"
        ],
        lineHeight: [
            "25.6px",
            null,
            "25.6px",
            "160%"
        ],
        letterSpacing: [
            "-1.4%",
            "-0.014em",
            "-0.014em",
            "-0.018em"
        ]
    },
    // Used in Hero, ReviewCard
    120: {
        fontSize: "18px",
        lineHeight: "120",
        letterSpacing: "-2.4"
    },
    // Used in StickyCTAUtility
    130: {
        fontSize: [
            "16px",
            null,
            "19px"
        ],
        lineHeight: "19px",
        letterSpacing: "-2.4"
    },
    // Used in Footer, Hero
    140: {
        fontSize: "22px",
        lineHeight: "112",
        letterSpacing: "-2.4"
    },
    // Used in FAQsDisplay, MapBackgroundHero, Steps, Testimonials, TextSection
    150: {
        fontSize: [
            "16px",
            null,
            null,
            "24px"
        ],
        lineHeight: [
            "130%",
            null,
            null,
            "112%"
        ],
        letterSpacing: [
            "-0.014em",
            null,
            null,
            "-0.028em"
        ]
    },
    // Used in HeroCard, VideoHero
    160: {
        fontSize: [
            "18px",
            "19px",
            null,
            "28px"
        ],
        lineHeight: [
            "120%",
            null,
            null,
            "110%"
        ],
        letterSpacing: [
            "-0.024em",
            "-0.02em",
            "-0.028em",
            "-0.028em"
        ]
    },
    // Used in CarouselCards, Footer
    170: {
        fontSize: [
            "32px",
            "36px",
            "44px",
            "56px"
        ],
        lineHeight: [
            "35.2px",
            "36px",
            "44px",
            "56px"
        ],
        letterSpacing: [
            "-2.8",
            "-3",
            "-3.4"
        ],
        fontWeight: 500
    },
    // Used in ImageCard
    180: {
        fontSize: [
            "16px",
            "18px",
            null,
            "28px"
        ],
        lineHeight: [
            "120%",
            null,
            null,
            "110%"
        ],
        letterSpacing: [
            "-0.024em",
            "-0.02em",
            "-0.028em",
            "-0.028em"
        ]
    },
    // Used in HeroCard, ImageCard
    220: {
        fontSize: [
            "22.2px",
            "28px",
            "36px",
            "56px"
        ],
        lineHeight: [
            "106%",
            "110%",
            "100%"
        ],
        letterSpacing: [
            "-0.024em",
            "-0.028em",
            "-0.03em",
            "-0.034em;"
        ]
    },
    // Used in FAQsDisplay, MapBackgroundHero, TextSection
    230: {
        fontSize: [
            "32px",
            "36px",
            "44px",
            "64px"
        ],
        lineHeight: [
            "110%",
            "100%"
        ],
        letterSpacing: [
            "-0.028em",
            "-0.03em",
            "-0.03em",
            "-0.034em;"
        ]
    },
    240: {
        fontSize: [
            "36px",
            null,
            "80px"
        ],
        lineHeight: "100",
        letterSpacing: "-3.4"
    },
    250: {
        fontSize: [
            "44px",
            null,
            "88px"
        ],
        lineHeight: "100",
        letterSpacing: "-3.4"
    },
    260: {
        fontSize: [
            "60px",
            null,
            "96px"
        ],
        lineHeight: "100",
        letterSpacing: "-3.4"
    }
});
/* harmony default export */ var landing_pages_v2_Layout = (Layout);

// EXTERNAL MODULE: ./src/helpers/observability.ts + 57 modules
var observability = __webpack_require__(46442);
// EXTERNAL MODULE: ./src/components/shared/useOnLoad.ts
var useOnLoad = __webpack_require__(17919);
;// CONCATENATED MODULE: ./src/components/shared/usePromptGoogleOneTap.ts




/**
 * Prompt the user to sign in with Google One Tap with built in error tracking + analytics
 * @param page - The page name to use for analytics tracking
 */ var usePromptGoogleOneTap = function(page, onSuccess, disablePromptGoogleOneTap, delay) {
    var ref = (0,observability/* useObservability */.C3)(), trackEvent = ref.trackEvent, trackError = ref.trackError;
    var ref1 = (0,auth_fe_esm/* useAuth */.aC)(), authentication = ref1.authentication, refresh = ref1.refresh;
    var isAfterLoad = (0,useOnLoad/* useOnLoad */.g)();
    (0,react.useEffect)(function() {
        // don't fire off the import until the document is finished loading
        if (authentication.state !== "not_authenticated" || !isAfterLoad || disablePromptGoogleOneTap) {
            return;
        }
        var prompt = function() {
            Promise.all(/* import() */[__webpack_require__.e(6198), __webpack_require__.e(1878)]).then(__webpack_require__.bind(__webpack_require__, 91878)).then(function(param) {
                var promptGoogleOneTap = param.promptGoogleOneTap;
                promptGoogleOneTap("cosmos-".concat(page), function(redirectTo) {
                    onSuccess && onSuccess();
                    if (redirectTo) {
                        window.location.assign(redirectTo);
                    } else {
                        refresh();
                    }
                }, trackEvent, trackError);
            });
        };
        var timer;
        if (delay) {
            timer = setTimeout(prompt, delay);
        } else {
            prompt();
        }
        return function() {
            clearTimeout(timer);
        };
    }, [
        authentication.state,
        isAfterLoad,
        delay
    ]);
};

// EXTERNAL MODULE: ./src/schema/index.ts
var schema = __webpack_require__(22067);
;// CONCATENATED MODULE: ./src/pages/shared/LandingPageV2Layout.tsx













var getSeoBaseTags = function(fields) {
    var title = fields === null || fields === void 0 ? void 0 : fields.title;
    var metaDescription = fields === null || fields === void 0 ? void 0 : fields.metaDescription;
    var canonicalUrl = fields === null || fields === void 0 ? void 0 : fields.canonicalUrl;
    var robots = [];
    // only set these when they are explicitly set to false
    // otherwise assume indexing and follow should be allowed
    if ((fields === null || fields === void 0 ? void 0 : fields.index) === false) {
        robots.push("noindex");
    }
    if ((fields === null || fields === void 0 ? void 0 : fields.follow) === false) {
        robots.push("nofollow");
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("title", {
                children: title !== null && title !== void 0 ? title : "Opendoor | Sell your home the minute you’re ready."
            }, "title"),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                rel: "shortcut icon",
                href: (0,faviconPath/* default */.Z)({
                    railsEnv: globals/* DEPLOY_ENV */.Zp
                }),
                type: "image/png"
            }),
            metaDescription ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                name: "description",
                content: metaDescription
            }, "description") : null,
            canonicalUrl ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                rel: "canonical",
                href: canonicalUrl
            }, "canonical") : null,
            robots.length > 0 ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                name: "robots",
                content: robots.join(",")
            }, "robots") : null
        ]
    });
};
var getOpenGraphTags = function(openGraphFields) {
    var url = openGraphFields.url, type = openGraphFields.type, title = openGraphFields.title, description = openGraphFields.description, image = openGraphFields.image, siteName = openGraphFields.siteName;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                property: "og:title",
                content: title
            }, "og:title"),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                property: "og:type",
                content: type
            }, "og:type"),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                property: "og:url",
                content: url
            }, "og:url"),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                property: "og:image",
                content: image
            }, "og:image"),
            ",",
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                property: "og:description",
                content: description
            }, "og:description"),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                property: "og:site_name",
                content: siteName
            }, "og:site_name")
        ]
    });
};
var getJobPostingSchemaFromLoaderData = function(idToLoaderData) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.values(idToLoaderData)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var loaderData = _step.value;
            if (loaderData === null || loaderData === void 0 ? void 0 : loaderData.jobPostingSchema) {
                return loaderData.jobPostingSchema;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return null;
};
// when a no-code landing page needs to preload an image for performance reasons,
// it can include a `preloadImages` field in the loader data
// this function crunches the loader data and pulls out all the preload images
// so that the top-level page can include those preload urls in the Head section
var getPreloadsFromLoaderData = function(idToLoaderData) {
    return Object.values(idToLoaderData).map(function(loaderData) {
        return loaderData === null || loaderData === void 0 ? void 0 : loaderData.preloadImages;
    }).filter(function(preload) {
        return preload;
    }).flat();
};
var getLandingpageV2ServerSideProps = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(context) {
        var ref, pageNum, slug, props, showModal, excludedSlugs, modalProps, e;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!((ref = context.params) === null || ref === void 0 ? void 0 : ref.slug)) {
                        return [
                            2,
                            {
                                notFound: true
                            }
                        ];
                    }
                    pageNum = 1;
                    if (context.query.page) {
                        pageNum = parseInt(context.query.page);
                    }
                    if (pageNum < 1) pageNum = 1;
                    slug = "";
                    // if slug is a string and not an array
                    if (typeof context.query.slug === "string") {
                        slug = context.query.slug;
                    } else if (Array.isArray(context.query.slug)) {
                        slug = context.query.slug.join("/");
                    }
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        5,
                        ,
                        6
                    ]);
                    return [
                        4,
                        (0,cms/* fetchLandingPageV2BySlug */.AL)({
                            slug: slug,
                            requestUrl: context.resolvedUrl,
                            pageNum: pageNum,
                            locale: "en-US"
                        })
                    ];
                case 2:
                    props = _state.sent();
                    if (!props) {
                        return [
                            2,
                            {
                                notFound: true
                            }
                        ];
                    }
                    // check if the page is set to public, and reject if appropriate
                    // this is intended to block non-public pages from being directly accessed by users,
                    // while still letting them be used in experiments as treatments
                    if (context.query.public && props.public === false) {
                        return [
                            2,
                            {
                                notFound: true
                            }
                        ];
                    }
                    showModal = false;
                    excludedSlugs = [
                        "builder",
                        "agent",
                        "real-estate",
                        "homepage",
                        "login",
                        "register",
                        "reset-password",
                        "calculator",
                        "careers",
                        "safety",
                        "privacy"
                    ];
                    if (!excludedSlugs.every(function(excluded) {
                        return !slug.includes(excluded);
                    })) return [
                        3,
                        4
                    ];
                    showModal = true;
                    return [
                        4,
                        (0,cms/* getCashOfferModal */.Mq)()
                    ];
                case 3:
                    modalProps = _state.sent();
                    _state.label = 4;
                case 4:
                    return [
                        2,
                        {
                            props: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                                modalFields: showModal && modalProps ? {
                                    title: modalProps.fields.title,
                                    description: modalProps.fields.description,
                                    analyticsId: modalProps.fields.analyticsId
                                } : null,
                                showModal: !!(showModal && modalProps)
                            })
                        }
                    ];
                case 5:
                    e = _state.sent();
                    // eslint-disable-next-line no-console
                    console.error(e);
                    return [
                        2,
                        {
                            notFound: true
                        }
                    ];
                case 6:
                    return [
                        2
                    ];
            }
        });
    });
    return function getLandingpageV2ServerSideProps(context) {
        return _ref.apply(this, arguments);
    };
}();
var LandingPageV2Layout = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13;
    usePromptGoogleOneTap("landing-pages-v2-".concat(props.fields.slug), undefined, props.hideGoogleOneTap);
    var contextualData = {
        landingPageSlug: props.fields.slug
    };
    var imagePreloads = getPreloadsFromLoaderData(props.idToLoaderData);
    var jobPostingSchema = getJobPostingSchemaFromLoaderData(props.idToLoaderData);
    var openGraphFields = (ref = props.fields.openGraph) === null || ref === void 0 ? void 0 : ref.fields;
    var appleStatusBarColor = props.fields.slug === "homepage-syw-v2-home-guide" ? "black" : "default";
    var shouldIncludeTrustpilot = (ref1 = props.fields) === null || ref1 === void 0 ? void 0 : ref1.shouldShowTrustpilotReviews;
    // Check if this is a market page (slug format: landing-pages-v2/market-[market])
    var isMarketPage = props.fields.slug.startsWith("landing-pages-v2/market-");
    // Convert Contentful slug to public URL format for markdown alternate link
    var publicSlug = isMarketPage ? props.fields.slug.replace(/^landing-pages-v2\/market-/, "/sell/") : null;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(observability_slim/* AddContextualData */.up, {
        data: contextualData,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)((head_default()), {
                children: [
                    getSeoBaseTags((ref2 = props.fields.seoBase) === null || ref2 === void 0 ? void 0 : ref2.fields),
                    openGraphFields && getOpenGraphTags(openGraphFields),
                    isMarketPage && publicSlug && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                        id: "markdown-alternate",
                        rel: "alternate",
                        type: "text/markdown",
                        href: "".concat(publicSlug, ".md")
                    }, "markdown-alternate"),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                        name: "apple-mobile-web-app-status-bar-style",
                        content: appleStatusBarColor
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("script", {
                        type: "application/ld+json",
                        dangerouslySetInnerHTML: {
                            __html: JSON.stringify(schema/* HOMEPAGE_SCHEMA */.B)
                        }
                    }),
                    props.fields.jsonLdSchema && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("script", {
                        type: "application/ld+json",
                        dangerouslySetInnerHTML: {
                            __html: JSON.stringify(props.fields.jsonLdSchema).replace(/</g, "\\u003c")
                        }
                    }),
                    jobPostingSchema && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("script", {
                        type: "application/ld+json",
                        dangerouslySetInnerHTML: {
                            __html: JSON.stringify(jobPostingSchema).replace(/</g, "\\u003c")
                        }
                    }),
                    shouldIncludeTrustpilot && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("script", {
                        type: "text/javascript",
                        src: "//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js",
                        async: true
                    }),
                    imagePreloads.map(function(h) {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                            rel: "preload",
                            as: "image",
                            media: h.media,
                            // @ts-expect-error: react incorrectly capitalizes this if you use
                            // the "typescript" suggestion of `imgSrcSet`
                            imagesrcset: h.srcSet,
                            fetchpriority: "high"
                        }, h.key);
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                        rel: "preload",
                        as: "image",
                        href: "https://images.opendoor.com/source/s3/imgdrop-production/2023-08-1692902240043-86611.jpg?preset=square-512"
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(landing_pages_v2_Layout, {
                header: (ref3 = props.fields) === null || ref3 === void 0 ? void 0 : ref3.header,
                slug: "/".concat((ref4 = props.fields) === null || ref4 === void 0 ? void 0 : ref4.slug),
                footer: (ref5 = props.fields) === null || ref5 === void 0 ? void 0 : ref5.footer,
                showModal: props.showModal,
                modalTitle: (ref6 = props.modalFields) === null || ref6 === void 0 ? void 0 : ref6.title,
                modalDescription: (ref7 = props.modalFields) === null || ref7 === void 0 ? void 0 : ref7.description,
                modalAnalyticsId: (ref8 = props.modalFields) === null || ref8 === void 0 ? void 0 : ref8.analyticsId,
                extraLegalText: (ref9 = props.fields) === null || ref9 === void 0 ? void 0 : ref9.extraLegalText,
                showEligibilityLegal: (ref10 = props.fields) === null || ref10 === void 0 ? void 0 : ref10.showEligibilityLegal,
                showCustomerTestimonialLegal: (ref11 = props.fields) === null || ref11 === void 0 ? void 0 : ref11.showCustomerTestimonialLegal,
                showThePdpCopyrightLegal: (ref12 = props.fields) === null || ref12 === void 0 ? void 0 : ref12.showThePdpCopyrightLegal,
                showPromotionLegal: (ref13 = props.fields) === null || ref13 === void 0 ? void 0 : ref13.showPromotionLegal,
                children: props.children
            })
        ]
    });
};
/* harmony default export */ var shared_LandingPageV2Layout = (LandingPageV2Layout);


/***/ }),

/***/ 22067:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ HOMEPAGE_SCHEMA; },
/* harmony export */   "z": function() { return /* binding */ buildJobPostingSchema; }
/* harmony export */ });
var HOMEPAGE_SCHEMA = {
    "@context": "http://schema.org",
    "@type": "Organization",
    legalName: "Opendoor Labs, Inc.",
    alternateName: "Opendoor",
    url: "https://www.opendoor.com",
    contactPoint: {
        "@type": "ContactPoint",
        telephone: "+1-888-352-7075",
        contactType: "Customer Service"
    },
    address: {
        "@type": "PostalAddress",
        addressLocality: "San Francisco",
        addressCountry: "USA",
        postalCode: "94104",
        streetAddress: "1 Post St, Fl 11"
    },
    logo: "https://www.opendoor.com/w/wp-content/uploads/2019/04/Opendoor-Logo.jpg",
    sameAs: [
        "https://www.facebook.com/OpendoorHQ",
        "https://twitter.com/opendoor",
        "https://www.youtube.com/channel/UCKKVV4bx18EtclsdNOFzWBw",
        "https://www.linkedin.com/company/opendoor-com",
        "https://www.pinterest.com/opendoorhq",
        "https://en.wikipedia.org/wiki/Opendoor", 
    ]
};
var buildJobPostingSchema = function(job) {
    var schema = {
        "@context": "https://schema.org",
        "@type": "JobPosting",
        title: job.title,
        description: job.content,
        datePosted: job.first_published,
        hiringOrganization: {
            "@type": "Organization",
            name: "Opendoor",
            sameAs: "https://www.opendoor.com",
            logo: HOMEPAGE_SCHEMA.logo
        },
        jobLocation: {
            "@type": "Place",
            address: job.location.name
        },
        jobLocationType: job.location.name.toLowerCase().includes("remote") ? "TELECOMMUTE" : undefined,
        applicantLocationRequirements: job.location.name.toLowerCase().includes("remote") ? [
            {
                "@type": "Country",
                name: "US"
            },
            {
                "@type": "Country",
                name: "Canada"
            }, 
        ] : undefined
    };
    // Include baseSalary/employmentType from metadata if Greenhouse is configured with structured fields
    if (job.metadata) {
        var salaryMeta = job.metadata.find(function(m) {
            return [
                "salary_range",
                "salary",
                "compensation"
            ].includes(m.name.toLowerCase());
        });
        var employmentMeta = job.metadata.find(function(m) {
            return [
                "employment_type",
                "employment type"
            ].includes(m.name.toLowerCase());
        });
        if (salaryMeta === null || salaryMeta === void 0 ? void 0 : salaryMeta.value) schema.baseSalary = salaryMeta.value;
        if (employmentMeta === null || employmentMeta === void 0 ? void 0 : employmentMeta.value) schema.employmentType = employmentMeta.value;
    }
    // Remove undefined values
    return JSON.parse(JSON.stringify(schema));
};



/***/ }),

/***/ 71390:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var railsEnv_1 = __webpack_require__(27825);
var faviconPath = function (_a) {
    var _b = _a === void 0 ? {} : _a, admin = _b.admin, railsEnv = _b.railsEnv;
    var env = railsEnv || (0, railsEnv_1.getRailsEnv)();
    // these favicons created in this Figma document
    // https://www.figma.com/file/R2a9eL6fEQMq24CY2Q8752NB/Favicons?node-id=19%3A29
    if (admin) {
        if (env === 'development') {
            return 'https://imgdrop.imgix.net/1bd03e41b990465e93d1c5b90ba36c16.png';
        }
        else if (env === 'staging') {
            return 'https://imgdrop.imgix.net/a8dddd737aeb4780bf9e8edfa8bdc27b.png';
        }
        else if (env === 'qa') {
            return 'https://imgdrop.imgix.net/28c43a220c9247f1ba3764c6aa7f67b3.png';
        }
        return 'https://imgdrop.imgix.net/6f05fac182304e3d821592580acf3a68.png';
    }
    if (env === 'development') {
        return 'https://imgdrop.imgix.net/4ec068f491b4478293d83b56911a2f65.png';
    }
    else if (env === 'staging') {
        return 'https://imgdrop.imgix.net/006a1ec0195a4e95bea9bd906d99130c.png';
    }
    else if (env === 'qa') {
        return 'https://imgdrop.imgix.net/5618f1f758be4937861351a1c96548d6.png';
    }
    return 'https://imgdrop.imgix.net/cf88fd37a91e43b0b7aafe6b076d2810.png';
};
exports.Z = faviconPath;


/***/ })

}]);